/** HTTP-level error from the service or gateway. */
export class ApiError extends Error {
  constructor(
    message: string,
    public readonly status?: number,
    public readonly url?: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

/** Thrown when a route requires auth and no API key / access token is configured. */
export class AuthError extends Error {
  constructor(message = 'Not authenticated. Set an API key or access token first.') {
    super(message);
    this.name = 'AuthError';
  }
}

/** The remote job reported FAILED / TIMEOUT, or was cancelled. */
export class JobError extends Error {
  constructor(message: string, public readonly jobId?: string) {
    super(message);
    this.name = 'JobError';
  }
}

/** Build a readable error from a non-2xx fetch Response. */
export async function apiErrorFromResponse(response: Response): Promise<ApiError> {
  let detail = '';
  try {
    const contentType = response.headers.get('content-type') ?? '';
    detail = contentType.includes('application/json')
      ? JSON.stringify(await response.json())
      : await response.text();
  } catch {
    detail = '<unreadable body>';
  }
  if (response.status === 401 || response.status === 403) {
    detail = `Unauthorized. Did you forget to set the API key? ${detail}`;
  }
  return new ApiError(`API error (${response.status}) at ${response.url}: ${detail}`, response.status, response.url);
}
